import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DealActionStatusOutput',
  props: {
    type: null,
    text: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var statusWithIcon = computed(function () {
      var icon;
      switch (props.type) {
        case 'start':
        case 'check':
        case 'error':
          icon = 'info';
          break;
        case 'success':
          icon = 'check';
          break;
        default:
          icon = '';
      }
      return {
        type: props.type,
        icon: icon
      };
    });
    var statusLabel = computed(function () {
      var _props$text;
      return (_props$text = props.text) !== null && _props$text !== void 0 ? _props$text : props.empty;
    });
    return {
      __sfc: true,
      props: props,
      statusWithIcon: statusWithIcon,
      statusLabel: statusLabel,
      SIcon: SIcon
    };
  }
});